export default __webpack_public_path__ + "static/4-dd78bfb283d319a510033471004aa05f.jpeg";